import 'rxjs/add/observable/from';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/throttleTime';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Observable';
import type { RouterActionPush } from '@atlassian/react-resource-router';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import type { ActionsObservable, Action } from '../../state/types.tsx';
import {
	type SprintBoardlinkClickAction,
	SPRINT_BOARD_LINK_CLICK,
	sprintBoardLinkPermissionlessFlagRequest,
	sprintBoardLinkClickSuccess,
	sprintBoardLinkClickFailure,
} from '../../state/actions/sprints/board-link-click/index.tsx';
import {
	fetchBoardDetails,
	type BoardDetailsResponse,
} from '../../rest/fetch-board-details/index.tsx';

const getUserLocatedBoardUrl = (accountId: string, boardId: number | string) => {
	return `/jira/people/${accountId}/boards/${boardId}`;
};

const getProjectLocatedBoardUrl = (
	isCMPBoard: boolean,
	projectKey: string,
	boardId: number | string,
) => {
	return `/jira/software${isCMPBoard ? '/c' : ''}/projects/${projectKey}/boards/${boardId}`;
};

export const sprintBoardLinkClickEpic = (push: RouterActionPush) => (action$: ActionsObservable) =>
	action$
		.ofType(SPRINT_BOARD_LINK_CLICK)
		.throttleTime(1000)
		.mergeMap((action: SprintBoardlinkClickAction) => {
			const rapidViewId = action.payload.rapidViewId;
			const analyticsEvent = action.meta.analyticsEvent;

			return fetchBoardDetails(rapidViewId)
				.mergeMap((response: BoardDetailsResponse): Observable<Action> => {
					const type = response.type;
					const userAccountId = response.location?.userAccountId;
					const projectKey = response.location?.projectKey;

					if (userAccountId) {
						push(getUserLocatedBoardUrl(userAccountId, rapidViewId));
						return Observable.of(sprintBoardLinkClickSuccess(analyticsEvent));
					}

					if (projectKey && type) {
						push(getProjectLocatedBoardUrl(type !== 'simple', projectKey, rapidViewId));
						return Observable.of(sprintBoardLinkClickSuccess(analyticsEvent));
					}

					return Observable.of(sprintBoardLinkPermissionlessFlagRequest(analyticsEvent));
				})
				.catch((error) => {
					log.safeErrorWithoutCustomerData(
						'backlog.sprint-board-link-click.failure',
						'Failed to redirect to board',
						error,
					);

					return Observable.from([sprintBoardLinkClickFailure(analyticsEvent)]);
				});
		});
